import { VALIDITY_EXTEND_TIME } from './Constants';

export const validatePhone = (phoneNumber) => {
	return {
		query: `mutation {validatePhone(phone: "${phoneNumber}")}`,
		variables: null,
	};
};

export const validateEmail = (emailId) => {
	return {
		query: `mutation {validateEmail(email: "${emailId}")}`,
		variables: null,
	};
};

export const validatePhoneOtp = (phone, otp) => {
	return {
		query: `mutation {validatePhoneOtp(phone: "${phone}",otp: "${otp}")}`,
		variables: null,
	};
};

export const validateEmailOtp = (email, otp) => {
	return {
		query: `mutation {validateEmailOtp(email: "${email}",otp: "${otp}")}`,
		variables: null,
	};
};

export const phoneSignup = (phone, password, otpValidationToken) => {
	return {
		query: `mutation {phoneSignup(phone: "${phone}",password: "${password}",otpValidationToken: "${otpValidationToken}")}`,
		variables: null,
	};
};

export const emailSignup = (email, password, otpValidationToken) => {
	return {
		query: `mutation {emailSignup(email: "${email}",password: "${password}",otpValidationToken: "${otpValidationToken}")}`,
		variables: null,
	};
};

export const phoneSignin = (phone, password) => {
	return {
		query: `mutation {phoneSignin(phone: "${phone}",password: "${password}")}`,
		variables: null,
	};
};

export const emailSignin = (email, password) => {
	return {
		query: `mutation {
            emailSignin(email: "${email}",password: "${password}")}`,
		variables: null,
	};
};

export const refreshAccessTokenMutation = (accessToken) => {
	return {
		query: `mutation {refreshAccessToken(accessToken: "${accessToken}")}`,
		variables: null,
	};
};

export const listToStringList = (list) => {
    if (!list || list.length === 0) {
        return '[]';
    }
    let finalString = '[';
    list.forEach((element) => {
        let itemstring = '"' + element + '",';
        finalString = finalString.concat(itemstring);
    });
    let length = finalString.length;
    finalString = finalString.substring(0, length - 1).concat(']');
    return finalString;
};

export const languageListToStringList = (list) => {
	if (!list || list.length === 0) {
	  return '[]';
	}
	return '[' + list.map(element => `"${element}"`).join(',') + ']';
  };

export const updateProfileMutation = (accessToken, profile) => {
	let qualificationString = listToStringList(profile.qualifications);
	let languagesKnownString = languageListToStringList(profile.languagesKnown);
	// console.log('creating profile update mutation', profile);
	// age: ${profile.age},
	// let hour = profile.timeOfBirth ? profile.timeOfBirth.hour() : '00';
	// let minute = profile.timeOfBirth ? profile.timeOfBirth.minute() : '00';
	let dobWithTime = profile.dob;
	if (!profile.dob.includes('T')) {
		let extractedTimeofBirth = profile.timeOfBirth
			? profile.timeOfBirth.$d.toLocaleTimeString('it-IT')
			: '00:00:00';
		dobWithTime = profile.dob + 'T' + extractedTimeofBirth + '+05:30';
	}
	return {
		query: `mutation {updateProfile(accessToken: "${accessToken}",profileUpdate:{
                  firstName: "${profile.firstName}",
                  lastName: "${profile.lastName}",
				  dob: "${dobWithTime}",
                  gender: "${profile.gender}",
                  city: "${profile.city}",
                  state: "${profile.state}",
                  zipCode: "${profile.pin}",
                  country: "${profile.country}",
                  qualifications: ${qualificationString},
                  occupation: "${profile.occupation}",
                  employedIn: "${profile.employedIn}",
                  annualIncome: "${profile.annualIncome}",
				  rashi: "${profile.rashi}",
                  isNri:${
						profile.isNRI !== undefined
							? profile.isNRI
							: profile.isNri
					}  ,
                  maritalStatus: "${profile.maritalStatus}",
                  motherTongue: "${profile.motherTongue}",
                  religion: "${profile.religion}",
                  caste: "${profile.caste}",
				  kuldevta: "${profile.kuldevta}",
				  nakshatra: "${profile.nakshatra}",
				  gotra: "${profile.gotra}",
                  languagesKnown: ${languagesKnownString},
                  bloodGroup: "${profile.bloodGroup}",
                  height: ${profile.height},
                  weight: ${profile.weight},
                  foodHabits: "${profile.foodHabits}",
                  drinkingHabits: "${profile.drinkingHabits}",
                  smokingHabits: "${profile.smokingHabits}",
                  fatherName: "${profile.fatherName}",
                  fatherNumber: "${profile.fatherNumber}",
                  motherName: "${profile.motherName}",
                  motherNumber: "${profile.motherNumber}",
				  contactNumber: "${profile.contactNumber}",
				  contactEmail: "${profile.contactEmail}",
                  bio: "${profile.bio}",
                  userPreferences: "${profile.userPreferences}",
				  math: "${profile.math}"})}`,
		variables: null,
	};
};

export const updateProfileImageMutation = (accessToken, keys) => {
	// Convert array of keys to JSON array string format
	const keysString = Array.isArray(keys) 
		? JSON.stringify(keys)  // This will create ["id1", "id2", ...]
		: JSON.stringify([keys]); // Handle single key case
	
	return {
		query: `mutation {
            markUploadedImageAsProfilePicture(accessToken: "${accessToken}",uploadKeys: ${keysString})}`,
		variables: null,
	};
};

export const adminMarkUploadedImageAsProfilePictureMutation = (accessToken, uploadKeys, userId) => {
	// Convert array of keys to JSON array string format
	const keysString = Array.isArray(uploadKeys) 
		? JSON.stringify(uploadKeys)  // This will create ["id1", "id2", ...]
		: JSON.stringify([uploadKeys]); // Handle single key case
	
	return {
		query: `mutation {
            adminMarkUploadedImageAsProfilePicture(accessToken: "${accessToken}",uploadKeys: ${keysString}, userId: "${userId}")}`,
		variables: null,
	};
};

export const addFavouriteMutation = (accessToken, userId) => {
	return {
		query: `mutation {
            addFavourite(accessToken: "${accessToken}",toFavouriteUserId: "${userId}")}`,
		variables: null,
	};
};

export const removeFavouriteMutation = (accessToken, userId) => {
	return {
		query: `mutation {
            removeFavourite(accessToken: "${accessToken}",removeFavouriteUserId: "${userId}")}`,
		variables: null,
	};
};

export const updatePassword = (accessToken, oldPassword, newPassword) => {
	return {
		query: `mutation {
            changePassword(accessToken: "${accessToken}",oldPassword: "${oldPassword}", newPassword: "${newPassword}")}`,
		variables: null,
	};
};

// Admin mutations
export const adminUpdateProfileMutation = (accessToken, profile) => {
	let qualificationString = listToStringList(profile.qualifications);
	let languagesKnownString = listToStringList(profile.languagesKnown);

	let dobWithTime = profile.dob;
	if (!profile.dob.includes('T')) {
		let extractedTimeofBirth = profile.timeOfBirth
			? profile.timeOfBirth.$d.toLocaleTimeString('it-IT')
			: '00:00:00';
		dobWithTime = profile.dob + 'T' + extractedTimeofBirth + '+05:30';
	}

	const bio = profile.bio ? profile.bio.replace(/\n/g, '\\n') : '';
	const userPreferences = profile.userPreferences ? profile.userPreferences.replace(/\n/g, '\\n') : '';

	return {
		query: `mutation {adminModifyProfileForUser(accessToken: "${accessToken}",
 			userId:"${profile.id}",
			profileUpdate:{
                  firstName: "${profile.firstName}",
                  lastName: "${profile.lastName}",
				  dob: "${dobWithTime}",
                  gender: "${profile.gender}",
                  city: "${profile.city}",
                  state: "${profile.state}",
                  zipCode: "${profile.pin}",
                  country: "${profile.country}",
                  qualifications: ${qualificationString},
                  occupation: "${profile.occupation}",
                  employedIn: "${profile.employedIn}",
                  annualIncome: "${profile.annualIncome}",
                  isNri:${
						profile.isNRI !== undefined
							? profile.isNRI
							: profile.isNri
					}  ,
                  maritalStatus: "${profile.maritalStatus}",
                  motherTongue: "${profile.motherTongue}",
                  religion: "${profile.religion}",
                  caste: "${profile.caste}",
				  kuldevta: "${profile.kuldevta}",
				  nakshatra: "${profile.nakshatra}",
				  rashi: "${profile.rashi}",
				  gotra: "${profile.gotra}",
                  languagesKnown: ${languagesKnownString},
                  bloodGroup: "${profile.bloodGroup}",
                  height: ${profile.height},
                  weight: ${profile.weight},
                  foodHabits: "${profile.foodHabits}",
                  drinkingHabits: "${profile.drinkingHabits}",
                  smokingHabits: "${profile.smokingHabits}",
                  fatherName: "${profile.fatherName}",
                  fatherNumber: "${profile.fatherNumber}",
                  motherName: "${profile.motherName}",
                  motherNumber: "${profile.motherNumber}",
				  contactNumber: "${profile.contactNumber}",
				  contactEmail: "${profile.contactEmail}",
                  bio: "${bio}",
				  userPreferences: "${userPreferences}",
				  math: "${profile.math}"})}`,
		variables: null,
	};
};

export const adminDisableProfileMutation = (accessToken, userId) => {
	return {
		query: `mutation {
            adminDisableProfile(accessToken: "${accessToken}",userId: "${userId}")}`,
		variables: null,
	};
};

export const adminEnableProfileMutation = (accessToken, userId) => {
	return {
		query: `mutation {
            adminEnableProfile(accessToken: "${accessToken}",userId: "${userId}")}`,
		variables: null,
	};
};

export const adminDisableUserMutation = (accessToken, userId) => {
	return {
		query: `mutation {
            adminDisableUser(accessToken: "${accessToken}",userId: "${userId}")}`,
		variables: null,
	};
};

export const adminEnableUserMutation = (accessToken, userId) => {
	return {
		query: `mutation {
            adminEnableUser(accessToken: "${accessToken}",userId: "${userId}")}`,
		variables: null,
	};
};

export const adminExtendValidityProfileMutation = (accessToken, userId) => {
	return {
		query: `mutation {
            adminExtendValidityByDays(accessToken: "${accessToken}",userId: "${userId}", numDays: ${VALIDITY_EXTEND_TIME})}`,
		variables: null,
	};
};

export const forgotPasswordPhoneMutation = (phoneNumber) => {
	return {
		query: `mutation {sendPasswordResetLinkOnPhone(phone: "${phoneNumber}")}`,
		variables: null,
	};
};

export const forgotPasswordEmailMutation = (emailId) => {
	return {
		query: `mutation {sendPasswordResetLinkOnEmail(email: "${emailId}")}`,
		variables: null,
	};
};

export const resetPasswordPhoneMutation = (token, password) => {
	return {
		query: `mutation {resetForgottenPasswordByPhone(token: "${token}", newPassword:"${password}")}`,
		variables: null,
	};
};

export const resetPasswordEmailMutation = (token, password) => {
	return {
		query: `mutation {resetForgottenPasswordByEmail(token: "${token}", newPassword:"${password}")}`,
		variables: null,
	};
};

export const adminResetUserPasswordMutation = (token, userId, password) => {
	return {
		query: `mutation {adminUpdateUserPassword(accessToken: "${token}", userId:"${userId}",password:"${password}")}`,
		variables: null,
	};
};

export const adminCreateUserWithEmailMutation = (token, email, password) => {
	return {
		query: `mutation {adminCreateNewUserWithEmail(accessToken:"${token}",email:"${email}", password:"${password}")}`,
		variables: null,
	};
};

export const adminCreateUserWithPhoneMutation = (token, phone, password) => {
	return {
		query: `mutation {adminCreateNewUserWithPhone(accessToken:"${token}",phone:"+91${phone}", password:"${password}")}`,
		variables: null,
	};
};

export const userReportsProfileMutation = (token, report) => {
	return {
		query: `mutation {
			userReportPerson (
				accessToken: "${token}",
				report: {
					reportedPerson: "${report.id}",
					userComment: "${report.comment}",
					reportType: "${report.type}",
				}
			)
		}`,
		variables: null,
	};

}

export const createOrderMutation = (token) => {
	return {
		query: `mutation {
			createOrder (
				accessToken: "${token}"
			) {
				orderId,
				amount,
				remainingTimeInSeconds
			}
		}`,
		variables: null,
	};
}

export const validateOrderMutation = (token, paymentId, signature) => {
	return {
		query: `mutation {
			ValidatePayment (
				accessToken: "${token}", 
				paymentId: "${paymentId}",
				signature: "${signature}", 
			)
		}`,
		variables: null,
	};
}

export const cancelOrderMutation = (token, orderId) => {
	return {
		query: `mutation {
			cancelOrder (
				accessToken: "${token}", 
				orderId: "${orderId}" 
			)
		}`,
		variables: null,
	};
}

export const adminCloseUserOpenReportsMutation = (token, userId, report) => {
  return {
    query: `mutation {
      adminCloseUserOpenReports (
        accessToken: "${token}",
        userId: "${userId}",
       	adminReport: {
			adminComment:"${report.adminComment}",
			marriedTime: "${report.marriedTime}",
			platformUsed: "${report.platformUsed}",
			platformRole: "${report.platformRole}",
			userFeedback: "${report.userFeedback}",
			partnerName: "${report.partnerName}"
		}
      )
    }`,
    variables: null,
  };
};

export const updateFilterPreferenceMutation = (token, userPreference) => {
	return {
		query: `mutation {
			updateUserFilterPreference(
				accessToken: "${token}",
				filterString: "${userPreference}"
			)
		}`
	}
}

export const extendProfileCompleteReminderMutation = (token) => {
	return {
		query: `mutation {
			extendProfileCompleteReminder(accessToken: "${token}")
		}`
	}
}
export const addUserAcknowledgementMutation = (token, ackType, version, remark) => {
	return {
		query: `mutation {
			addUserAcknowledgement(
				accessToken: "${token}",
				ackType: "${ackType}",
				version: "${version}",
				remark: "${remark}"
			)
		}`
	};
};

export const adminTriggerReindexMutation = (accessToken) => {
	return {
		query: `mutation {
			adminTriggerCompleteSearchIndexRebuild(accessToken: "${accessToken}")
		}`,
		variables: null,
	};
};
